


















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class LikeSolid extends Vue {
  @Prop() hasLiked;
  get className() {
    return this.hasLiked ? 'svg-primary' : '';
  }
}
